import styled from 'styled-components'

export const FieldLabelStyled = styled.span`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  font-weight: ${(props) => props.theme.fontWeights.bold};
  line-height: 1.5;
  color: ${(props) => props.theme.colors.textPrimary};
`
